<template>
  <div class="wayline-settings">
    <div class="wayline-settings__header">
      <el-form ref="formRef" :model="waylineInfo" :rules="rules" style=" flex:1">
        <el-form-item prop="name" style="margin-bottom: 0px !important;">
          <el-input class="c-el-input-blue wayline-name-input" v-model="waylineInfo.name"
            :placeholder="$t('route.waypoint.enterRouteName')" :disabled="!editable"></el-input>
        </el-form-item>
      </el-form>
      <div class="wayline-type" style="margin-left:6px">{{ waylineTypeText }}</div>
      <el-popover trigger="hover" popper-class="c-el-popover-blue" style="margin-left: 4px; flex-shrink: 0;"
        placement="bottom" width="200">
        <i slot="reference" style="font-size: 18px; " class="el-icon-question"></i>
        <div>
          <p>1.{{ $t('route.waypoint.speedLimit') }}</p>
          <p>2.{{ $t('route.waypoint.headingSet') }}</p>
          <!-- <p>
            3.{{ $t('route.waypoint.RecordLimit') }}
          </p> -->
          <p>3.{{ $t('route.waypoint.M300RTK') }}</p>
        </div>
      </el-popover>
    </div>
    <div class="wayline-settings__body">
      <el-row class="wayline-stats-container">
        <el-col :span="6" class="wayline-stats-item" v-if="showArea">
          <div class="value-wrapper">
            <span class="value">{{ area }}</span>
            <span class="unit">km²</span>
          </div>
          <div class="label">{{ $t('route.waypoint.area') }}</div>
        </el-col>
        <el-col :span="6" class="wayline-stats-item">
          <div class="value-wrapper">
            <span class="value">{{ totalDistance }}</span>
            <span class="unit">km</span>
          </div>
          <div class="label">{{ $t('route.waypoint.routelength') }}</div>
        </el-col>
        <el-col :span="6" class="wayline-stats-item">
          <div class="value-wrapper">
            <span class="value"> {{ totalTime }}</span>
            <span class="unit">min</span>
          </div>
          <div class="label">{{ $t('route.waypoint.estimatedflighttime') }}</div>
        </el-col>
        <el-col v-if="!isAreaRoute" :span="6" class="wayline-stats-item">
          <div class="value-wrapper">
            <span class="value"> {{ pointsLength }}</span>
          </div>
          <div class="label">{{ $t('route.waypoint.waypointsCount') }}</div>
        </el-col>
        <el-col :span="6" class="wayline-stats-item">
          <div class="value-wrapper">
            <span class="value">{{ photos }}</span>
          </div>
          <div class="label">{{ $t('route.waypoint.photos') }}</div>
        </el-col>
      </el-row>
      <div class="wayline-tabs">
        <div class="wayline-tabs__header">
          <div @click="currentTabIndex = 1" class="wayline-tabs__item" :class="{ 'is-active': currentTabIndex === 1 }">
            {{
              $t('route.waypoint.routeSettings') }}</div>
          <div @click="currentTabIndex = 2" v-if="!isAreaRoute" class="wayline-tabs__item"
            :class="{ 'is-active': currentTabIndex === 2 }">
            {{ $t('route.waypoint.waypointSettings') }}
          </div>
        </div>
        <div class="wayline-tabs__content" v-if="currentTabIndex === 1">
          <CustomElScrollbar class="c-scrollbar">
            <div class="c-scrollbar__content">
              <el-form ref="configFormRef" :model="waylineInfo.config" :rules="configFormRules" :disabled="!editable">
                <el-form-item label="">
                  <div class="form-item-content">
                    <img class="icon-img" src="../../../imgs/icon_land.png" />
                    <div class="form-item-label">{{ $t('route.waypoint.selectDock') }}</div>
                  </div>
                  <el-select v-model="waylineInfo.siteId" :disabled="!editable" class="el-select-blue"
                    popper-class="select-mask" style="width:100%" @change="handleSelectDockChange">
                    <el-option v-for="item in dockSiteList" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <template>
                  <el-row :gutter="8">
                    <el-col :span="12">
                      <el-form-item label="">
                        <div class="form-item-content">
                          <div class="form-item-label">{{ $t('route.waypoint.selectAircraft') }}</div>
                        </div>
                        <el-select v-model="waylineInfo.config.droneEnumValue" :disabled="!editable"
                          class="el-select-blue" popper-class="select-mask"
                          @change="() => { waylineInfo.config.camera = '' }">
                          <el-option v-for="item in deviceOptions" :key="item.type" :label="item.name"
                            :value="item.type">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12" v-if="cameraOptions.length > 0">
                      <el-form-item label="">
                        <div class="form-item-content">
                          <img class="icon-img" src="../../../imgs/Icon_cam.png" />
                          <div class="form-item-label">{{ $t('route.waypoint.selectCamera') }}</div>
                        </div>
                        <el-select v-model="waylineInfo.config.camera" :disabled="!editable" class="el-select-blue"
                          popper-class="select-mask" style="width:100%" @change="handleSelectCameraChange">
                          <el-option v-for="item in cameraOptions" :key="item.type" :label="item.name"
                            :value="item.type">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="8" v-if="cameraOptions.length > 0">
                    <el-col :span="24">
                      <el-form-item label="">
                        <div class="form-item-content">
                          <img class="icon-img" src="../../../imgs/Icon_cam.png" />
                          <div class="form-item-label">{{ $t('route.waypoint.selectLens') }}</div>
                          <el-checkbox-group v-model="waylineInfo.config.cameraLens" size="small"
                            @change="handleSelectLensChange" :disabled="!editable"
                            :class="{ 'el-checkbox-only-child': cameraLensOptions && cameraLensOptions.length === 1 }">
                            <div style="display: flex;align-items: center;justify-content: space-between;">
                              <el-checkbox class="camera-lens-checkbox" v-for="lensItem in cameraLensOptions"
                                :label="lensItem.value" :key="lensItem.value" :disabled="lensItem.disabled">{{
                                  lensItem.label }}
                              </el-checkbox>
                            </div>
                          </el-checkbox-group>
                        </div>

                      </el-form-item>
                    </el-col>
                  </el-row>
                </template>
                <el-form-item label="" class="el-form-item-blue">
                  <div class="form-item-content">
                    <div class="form-item-label" style="line-height: 1.3;">{{ $t('route.waypoint.altitudeMode') }}</div>
                    <el-radio-group v-model="waylineInfo.config.heightMode" size="small" :disabled="!editable">
                      <el-radio v-for="item in heeightModeOptions" :label="item.value" :key="item.value">
                        <el-tooltip popper-class="c-el-popover-blue opacity-1" placement="top">
                          <span> {{
                            $t(item.i18nkey)
                          }}</span>
                          <div slot="content" style="width:300px">
                            <icon-svg :name="item.svgIcon" />
                            <div>{{ $t(item.tipI18nKey) }}</div>
                          </div>

                        </el-tooltip>



                      </el-radio>


                    </el-radio-group>

                  </div>

                </el-form-item>

                <el-form-item label="" prop="altitude">
                  <div class="form-item-content">
                    <img class="icon-img" src="../../../imgs/icon_height.png" />
                    <div class="form-item-label"> {{ $t('route.waypoint.defaultAltitude') }}(m)</div>


                    <el-input-number v-model="waylineInfo.config.altitude" :disabled="!editable" size="mini"
                      class="c-el-input-number-blue input-number" :precision="1" :min="minGlobalHeight"
                      :max="maxGlobalHeight" @change="handleGlobalHeightChange" />

                  </div>
                  <!-- <el-slider class="slider-wrapper" v-model="waylineInfo.config.altitude" :min="minGlobalHeight"
                      :max="maxGlobalHeight"></el-slider> -->
                </el-form-item>
                <el-form-item label="" prop="altitude">
                  <div class="form-item-content">
                    <img class="icon-img" src="../../../imgs/icon_height.png" />
                    <div class="form-item-label">{{ $t('route.waypoint.globalRthHeight') }}(m)
                      <el-tooltip popper-class="c-el-popover-blue opacity-1" placement="top">
                        <i class="el-icon-question" />
                        <div slot="content" style="width:150px;line-height: 1.5;">{{ $t('route.waypoint.rthHeightTip')
                          }}</div>
                      </el-tooltip>
                    </div>


                    <el-input-number v-model="waylineInfo.config.returnFlight" :disabled="!editable" size="mini"
                      class="c-el-input-number-blue input-number" :precision="1" :min="minGlobalRTHHeight"
                      :max="maxGlobalRTHHeight" />

                  </div>

                </el-form-item>
                <!-- 重叠率相关设置只有面状航线和网格航线才显示 -->
                <template v-if="isAreaRoute || isGridWay">


                  <el-form-item label="">
                    <div class="form-item-content">

                      <div class="form-item-label">GSD ({{ $t('route.waypoint.wideAngle') }}) (cm/pixel)</div>

                      <el-input-number v-model="waylineInfo.config.gsdWide" :disabled="!editable"
                        class="c-el-input-number-blue input-number" size="mini" :min="minGsdWide" :max="maxGsdWide"
                        @change="handleGsdChange" />
                    </div>

                  </el-form-item>
                  <el-form-item label="" v-if="isInfraredLensChecked">
                    <div class="form-item-content">

                      <div class="form-item-label">GSD ({{ $t('route.waypoint.infrared') }}) (cm/pixel)</div>

                      <el-input-number v-model="waylineInfo.config.gsdInfrared" :disabled="!editable"
                        class="c-el-input-number-blue input-number" size="mini" :min="minGsdWide" :max="maxGsdWide"
                        @change="handleGsdInfraredChange" />
                    </div>

                  </el-form-item>
                  <el-form-item label="" prop="sidelap">
                    <div class="form-item-content">
                      <img class="icon-img" src="../../../imgs/Icon_sideOverlapRatio.png" />
                      <div class="form-item-label">{{ $t('route.waypoint.sideOverlap') }}(%)</div>

                      <el-input-number v-model="waylineInfo.config.sidelap" :disabled="!editable"
                        class="c-el-input-number-blue input-number" size="mini" :min="minOverlapW" :max="maxOverlapW"
                        :precision="0" @change="handleSidelapChange" />
                    </div>
                    <!-- <div class="slider-wrapper">
                      <el-slider v-model="waylineInfo.config.sidelap" :min="minOverlapW" :max="maxOverlapW"></el-slider>
                    </div> -->
                  </el-form-item>

                  <el-form-item label="" prop="course">
                    <div class="form-item-content">
                      <img class="icon-img" src="../../../imgs/Icon_courseOverlapRatio.png" />
                      <div class="form-item-label">{{ $t("route.waypoint.forwardOverlap") }}(%)</div>

                      <el-input-number size="mini" v-model="waylineInfo.config.course" :disabled="!editable"
                        @change="handleCourseChange" class="c-el-input-number-blue input-number" />


                    </div>
                    <!-- <div class="slider-wrapper">
                      <el-slider v-model="waylineInfo.config.course" :min="minOverlapH" :max="maxOverlapH"></el-slider>

                    </div> -->
                  </el-form-item>
                </template>

                <template v-if="waylineType === WaylineTemplateType.polygon">
                  <!-- 航线间隔设置只有在多边形模式下才显示 -->
                  <el-form-item label="" prop="sidelapSpacing">
                    <div class="form-item-content">
                      <img class="icon-img" src="../../../imgs/Icon_gap.png" />
                      <div class="form-item-label"> {{ $t('route.waypoint.sidelapSpacing') }}(m)</div>

                      <el-input-number v-model="waylineInfo.config.sidelapSpacing" :disabled="!editable" size="mini"
                        class="c-el-input-number-blue input-number" :precision="1" :min="2" :max="500"
                        @change="generateWaypoints()" />
                    </div>

                  </el-form-item>
                  <el-form-item label="" prop="space">
                    <div class="form-item-content">
                      <img class="icon-img" src="../../../imgs/Icon_gap.png" />
                      <div class="form-item-label"> {{ $t('route.waypoint.forwardSpacing') }}(m)</div>

                      <el-input-number v-model="waylineInfo.config.forwardSpacing" :disabled="!editable" size="mini"
                        class="c-el-input-number-blue input-number" :precision="1" :min="2" :max="500"
                        @change="generateWaypoints()" />
                    </div>

                  </el-form-item>
                  <el-form-item label="" prop="rotate">
                    <div class="form-item-content">
                      <img class="icon-img" src="../../../imgs/Icon_angle.png" />
                      <div class="form-item-label"> {{ $t('route.waypoint.courseAngle') }}(°)</div>
                      <el-input-number v-model="waylineInfo.config.rotate" :disabled="!editable" size="mini"
                        class="c-el-input-number-blue input-number" :precision="0" :min="0" :max="360"
                        @change="generateWaypoints()" />

                    </div>
                    <el-slider style="margin-left: 8px" v-model="waylineInfo.config.rotate" :max="360" :min="0"
                      @change="generateWaypoints()"></el-slider>
                  </el-form-item>

                </template>

                <el-form-item label="" prop="speed">
                  <div class="form-item-content">
                    <img class="icon-img" src="../../../imgs/icon_speed.png" />
                    <div class="form-item-label">{{ $t('route.waypoint.defaultSpeed') }}(m/s)</div>

                    <el-input-number v-model="waylineInfo.config.speed" :disabled="!editable"
                      class="c-el-input-number-blue input-number" size="mini" :precision="0" :min="minFlightSpeed"
                      :max="maxFlightSpeed" @change="handleGlobalSpeedChange" />

                  </div>
                  <!-- <el-slider class="slider-wrapper" v-model="waylineInfo.config.speed" :max="maxFlightSpeed"
                      :min="minFlightSpeed"></el-slider> -->
                </el-form-item>
                <el-form-item label="" prop="speed">
                  <div class="form-item-content">

                    <div class="form-item-label" style="flex-shrink: 0;margin-bottom: 5px;">存储照片类型</div>

                    <ImageFormatCheckbox v-model="waylineInfo.config.imageFormat" :disabled="!editable"
                      :options="isInfraredLensChecked ? ['visable', 'ir'] : ['visable']" />

                  </div>

                </el-form-item>

                <el-form-item label="" prop="headerOptions">
                  <div class="form-item-content">
                    <img class="icon-img" src="../../../imgs/Icon_drone.png" />
                    <div class="form-item-label"> {{ $t('route.waypoint.heading') }}</div>
                  </div>
                  <el-select v-model="waylineInfo.config.headingMode" class="el-select-blue" popper-class="select-mask"
                    :disabled="isGridWay || !editable" style="width:100%">
                    <el-option v-for="item in headerOptions" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="" prop="finishedAction">
                  <div class="form-item-content">
                    <img class="icon-img" src="../../../imgs/Icon_doc_setting.png" />
                    <div class="form-item-label"> {{ $t('route.waypoint.taskCompleteAction') }}</div>
                  </div>
                  <el-select v-model="waylineInfo.config.finishedAction" class="el-select-blue"
                    popper-class="select-mask" style="width:100%" :disabled="!editable">
                    <el-option v-for="item in finishActionOptions" :key="item.value" :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                <template v-if="waylineInfo.config.finishedAction === 'PRELAND'">
                  <el-form-item label="" prop="startPoint">
                    <div class="form-item-content">
                      <div class="form-item-label">起始点</div>
                      <el-select v-model="waylineInfo.config.startPoint" class="el-select-blue"
                        popper-class="select-mask" style="width:200px" :disabled="!editable"
                        @change="handleLandPointChange($event, 'startPoint')">
                        <el-option v-for="item in landPointOptions" :key="item.id" :label="item.name" :value="item.id"
                          style="height:auto;line-height: 1.5;">
                          <LandingPoint :data="item" />
                        </el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                  <el-form-item label="" prop="endPoint">
                    <div class="form-item-content">
                      <div class="form-item-label">终止点</div>
                      <el-select v-model="waylineInfo.config.endPoint" class="el-select-blue" popper-class="select-mask"
                        style="width:200px" @change="handleLandPointChange($event, 'endPoint')">
                        <el-option v-for="item in landPointOptions" :key="item.id" :label="item.name" :value="item.id"
                          style="height:auto;line-height: 1.5;">
                          <LandingPoint :data="item" />
                        </el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                  <el-form-item label="" prop="landHeight">
                    <div class="form-item-content">
                      <img class="icon-img" src="../../../imgs/icon_height.png" />
                      <div class="form-item-label"> {{ $t('route.waypoint.landHeight') }}(m)</div>
                      <el-input-number v-model="waylineInfo.config.landHeight" :disabled="!editable" size="mini"
                        class="c-el-input-number-blue input-number" :max="maxGlobalHeight"
                        @change="handleGlobalHeightChange" />

                    </div>

                  </el-form-item>

                </template>
              </el-form>
            </div>
          </CustomElScrollbar>
        </div>
        <div class="wayline-tabs__content" v-else-if="currentTabIndex === 2">
          <CustomElScrollbar class="c-scrollbar">
            <div style="padding:12px 12px 0px 0px;text-align: right;" v-if="editable && isWaypointRoute">
              <el-input-number v-model="deleteRange.start" class="c-el-input-number-blue" :controls="false"
                style="width:90px" size="mini" :placeholder="$t('route.point.startIndex')" :min="1"
                :max="waypointList.length"></el-input-number>
              <span style="margin:0 6px">~</span>
              <el-input-number v-model="deleteRange.end" class="c-el-input-number-blue" :controls="false"
                style="width:90px" size="mini" :placeholder="$t('route.point.endIndex')" :min="1"
                :max="waypointList.length"></el-input-number>
              <span style="margin-left: 8px;">
                <el-popconfirm
                  :title="$t('route.point.confirmDeleteRange', { start: deleteRange.start, end: deleteRange.end })"
                  @confirm="handleBatchDeleteWaypoint(deleteRange.start, deleteRange.end)">
                  <el-button slot="reference" size="mini" icon="el-icon-delete" type="danger" plain
                    style="padding:6px 8px"></el-button>
                </el-popconfirm>
              </span>
            </div>
            <div class="c-scrollbar__content" style="padding:12px;width: 100%;overflow: hidden;">
              <WaypointListPanel :waypoints="waypointList" :waylineConfig="waylineConfig" :editable="editable"
                :showDelete="showDelete" @waypointListChange="handleWaypointListChange">
              </WaypointListPanel>
            </div>
          </CustomElScrollbar>
        </div>
      </div>
    </div>

    <div class="wayline-settings__footer">
      <div>
        <el-button class="el-btn" size="small" @click="cancelClick">{{ $t('common.btnClose') }}</el-button>
      </div>
      <div v-if="editable">
        <el-button :loading="saveLoading" class="el-btn" size="small" type="primary" @click="saveClick">{{
          $t('common.btnSave') }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import WaylineUtil from '../../../util/WaylineUtil';

import { CameraOptions, DeviceOptions } from "../../../constant/devices.js"
import { WaylineTemplateType, HeightModes, FinishAction } from "../../../constant/constant.js"
import WaypointListPanel from '../WaypointListPanel'
import * as MapUtils from '@/components/map/utils/index.js'
import { debounce } from '@/utils/common.js'
import DockApi from '@/api/flight/dock';
import RouteApi from '@/api/flight/route';
import ImageFormatCheckbox from '../ImageFormatCheckbox.vue'
import LandingPoint from '../LandingPoint'

export default {
  name: "WaylineSetting",
  components: {
    WaypointListPanel,
    ImageFormatCheckbox,
    LandingPoint
  },
  props: {
    waylineInfo: {//航线信息
      type: Object,
      default: () => { },
      required: true
    },
    gridInfo: {//网格信息
      type: Object,
      default: null
    },

    editable: {//是否可编辑
      type: Boolean,
      default: false
    },
    saveLoading: {
      //保存按钮加载状态
      type: Boolean,
      default: false
    }

  },

  data() {
    return {

      WaylineTemplateType: WaylineTemplateType,
      currentTabIndex: 1,//当前tab索引
      dockSiteList: [],//机库站点列表
      //inputNumber限制输入的值
      minFlightSpeed: 1,//全局航线最小飞行速度m/s
      maxFlightSpeed: 15,//全局航线最大飞行速度m/s
      minGlobalHeight: 1,//全局航线最小高度m
      maxGlobalHeight: 500,//全局航线高度m
      minGlobalRTHHeight: 20,//全局返航高度最小高度m
      maxGlobalRTHHeight: 1500,//全局返航高度最大高度m
      minOverlapW: 10,//最小旁向重叠率
      maxOverlapW: 90,//最大旁向重叠率
      minOverlapH: 10,//最小航向重叠率
      maxOverlapH: 90,//最大航向重叠率
      minGsdWide: 0.89,//最小GSD广角
      maxGsdWide: 50.0,//最大GSD广角
      deleteRange: {//批量删除航点范围
        start: undefined,
        end: undefined
      },
      debounceCalcStatistics: () => { },//计算统计信息的防抖函数
      //起降点选项
      landPointOptions: []
    };
  },
  computed: {
    rules() {
      return {

        name: [{ required: true, message: this.$t('route.waypoint.nameRequired'), trigger: 'blur' }]
      }
    },
    configFormRules() {
      return {
        landHeight: [{ required: true, type: 'number', message: "请输入起降点高度", trigger: 'blur' }],
        startPoint: [{ required: true, message: "请选择起始点", trigger: 'blur' }],
        endPoint: [{ required: true, message: "请选择终止点", trigger: 'blur' }],
      }
    },
    /**
    * 判断是否为网格航线
    *
    * @returns {boolean} 如果为网格方式，返回 true；否则返回 false
    */
    isGridWay() {
      let flag = false
      if (this.waylineInfo) {
        flag = !!this.waylineInfo.gridId
      }
      return flag
    },
    /**
  * 航线类型
  */
    waylineType() {
      let config = this.waylineConfig || {}
      return config.type
    },
    /**
     * 判断是否为航点航线
     */
    isWaypointRoute() {
      return this.waylineType == WaylineTemplateType.LineString && !this.isGridWay
    },
    /**
     * 判断是否为面状航线
     */
    isAreaRoute() {
      return this.waylineType == WaylineTemplateType.mapping2d
    },
    area() {//航线面积
      return this.waylineConfig.polygonArea || 0
    },
    totalDistance() {//航线长度
      return this.waylineInfo.distance || 0
    },
    totalTime() {//预计飞行时间
      return this.waylineInfo.estimateTime || 0
    },
    pointsLength() {//航点数量
      return this.waypointList.length
    },
    /**
     * 预计拍摄照片数量
     *
     * @returns {number} 返回照片数量，默认值为0
     */
    photos() {
      let sum = 0
      if (this.waylineInfo) {
        if (this.waylineInfo.config) {
          sum = this.waylineInfo.config.photos || 0
        }

      }

      return sum
    },
    waylineConfig() {
      return this.waylineInfo.config || {}
    },
    waypointList() {
      let list = []

      if (this.waylineConfig) {
        list = this.waylineConfig.points || []
      }
      return list
    },
    headerOptions() {
      return [
        {
          value: 'AUTO',
          label: this.$t('route.waypoint.autoAdjust'),
        },
        {
          value: 'FIXED',
          label: this.$t('route.waypoint.faceNorth'),
        },
        {
          value: 'CONTROL_BY_REMOTE_CONTROLLER',
          label: this.$t('route.waypoint.rcControl'),
        },
        {
          value: 'USING_WAYPOINT_HEADING',
          label: this.$t('route.waypoint.setInWaypoint'),
        },
      ]
    },
    finishActionOptions() {
      // return [
      //   {
      //     value: 'GO_HOME',
      //     label: this.$t('route.waypoint.returnHome'),
      //   },
      //   {
      //     value: 'NO_ACTION',
      //     label: this.$t('route.waypoint.hover'),
      //   },
      //   {
      //     value: 'GO_FIRST_WAYPOINT',
      //     label: this.$t('route.waypoint.flyToFirstWaypoint'),
      //   },
      //   {
      //     value: 'AUTO_LAND',
      //     label: this.$t('route.waypoint.land'),
      //   },

      //   {
      //     value: 'CONTINUE_UNTIL_END',
      //     label: this.$t('route.waypoint.awaitCommand'),
      //   },
      //   {
      //     value: 'PRELAND',
      //     label: this.$t('route.waypoint.preLand'),
      //   },
      // ]
      let list = []
      let droneEnumValue = this.waylineInfo.config.droneEnumValue
      Object.keys(FinishAction).forEach(key => {
        let item = FinishAction[key]
        if (!item.disabled) {
          if (item == FinishAction.PRELAND) {
            if (droneEnumValue == 'Q20Y') {
              list.push({
                value: item.value,
                label: this.$t(item.i18nkey) || item.value,
              })
            }
          } else {
            list.push({
              value: item.value,
              label: this.$t(item.i18nkey) || item.value,
            })
          }


        }

      })
      return list
    },
    deviceOptions() {
      return DeviceOptions || []
    },
    /**
   * 获取相机选项配置
   * @returns 返回相机选项配置对象
   */
    cameraOptions() {
      let list = []
      const droneEnumValue = this.waylineInfo.config.droneEnumValue
      if (droneEnumValue) {
        let droneDevice = DeviceOptions.find(item => item.type === droneEnumValue)

        if (droneDevice) {
          if (droneDevice.children) {
            droneDevice.children.forEach(item => {
              let payload = item.payload
              if (payload) {

                if (payload.cameras) {
                  list = list.concat(payload.cameras)
                }
              }
            })
          }
        }
      }

      return list
    },
    /**
     * 相机镜头选项
     *
     * @returns 返回相机镜头选项列表
     */
    cameraLensOptions() {
      let list = []
      let currentCamera = this.currentCamera || {}
      let checkedCameraLens = this.waylineConfig.cameraLens || []
      if (currentCamera) {
        if (currentCamera.wide) {
          let obj = {
            value: 'wide',
            label: this.$t('route.waypoint.wideAngle'),
            ...currentCamera.wide,
            disabled: false
          }

          if (checkedCameraLens.length === 1) {
            if (checkedCameraLens.includes('wide')) {
              obj.disabled = true
            }
          }
          list.push(obj)
        }
        if (currentCamera.infrared) {
          let obj = {
            value: 'infrared',
            label: this.$t('route.waypoint.infrared'),
            ...currentCamera.infrared,
            disabled: false
          }
          if (checkedCameraLens.length === 1) {
            if (checkedCameraLens.includes('infrared')) {
              obj.disabled = true
            }
          }
          list.push(obj)
        }
      }
      return list
    },
    /**
  * 当前选择的相机信息
  * @returns {Object} 当前摄像头信息
  */
    currentCamera() {
      let obj = null
      let type = ""
      if (this.waylineInfo && this.waylineInfo.config) {
        type = this.waylineInfo.config.camera
      }
      if (type) {
        obj = this.cameraOptions.find(item => item.type === type)
      }
      return obj
    },
    /**
   * 检查是否选择了红外镜头
   *
   * @returns {boolean} 如果选择了红外镜头，则返回 true；否则返回 false
   */
    isInfraredLensChecked() {
      let flag = false
      let cameraLens = this.waylineConfig.cameraLens || []
      if (cameraLens.includes('infrared')) {
        flag = true
      }
      return flag
    },
    /**
     *头部是否显示面积统计
     */
    showArea() {
      return this.isGridWay || this.waylineType === WaylineTemplateType.mapping2d
    },
    waylineTypeText() {
      let text = ""
      switch (this.waylineType) {
        case WaylineTemplateType.LineString:
          text = this.$t('route.waypoint.waypointMode')
          break;
        case WaylineTemplateType.mapping2d:
          text = this.$t('route.waypoint.areaRoute')
          break;
        default:
          text = this.$t('route.waypoint.waypointMode')
          break;
      }
      if (this.isGridWay) {
        text = this.$t('route.waypoint.gridRoute')
      }
      return text
    },
    showDelete() {
      return this.isWaypointRoute || this.waylineType === WaylineTemplateType.polygon || this.isGridWay
    },
    /**
    * 获取高度模式选项列表
    *
    * @returns 返回过滤后的高度模式列表，不包含被禁用的模式
    */
    heeightModeOptions() {
      let list = []
      for (let key in HeightModes) {
        if (HeightModes[key].disabled) {
          continue
        }
        list.push(HeightModes[key])
      }
      return list
    }

  },
  methods: {
    handleSelectDockChange(val) {
      if (!this.editable) return
      if (val) {
        let target = this.dockSiteList.find(item => item.id === val)
        if (target) {

          const { longitude, latitude } = target
          if (longitude && latitude) {
            this.waylineInfo.config.latlng = [longitude, latitude]
          }
          this.$emit("sekectDockChange", target)
        }
      }
    },
    /**
    * 处理全局速度变化
    *
    * @param val 新的全局速度值
    */
    handleGlobalSpeedChange(val) {
      if (!this.editable) return
      let waypoints = this.waylineConfig.points || []
      waypoints.forEach(item => {
        //如果航点设置了使用全局速度，则更新速度为新的全局速度值
        if (item.useGlobalSpeed) {
          item.speed = val
        }
      })

    },
    /**
  * 处理相机选择变更事件
  *
  * @param value 相机选择的值
  */
    handleSelectCameraChange() {
      if (!this.editable) return
      let currentCamera = this.currentCamera || {}
      let lens = "wide"
      if (currentCamera.infrared) {
        lens = "infrared"
        this.waylineConfig.cameraLens = ["wide", "infrared"]
        this.waylineConfig.imageFormat = "visable,ir"
      } else {
        this.waylineConfig.cameraLens = ["wide"]
        this.waylineConfig.imageFormat = "visable"
      }
      //重新计算GSD值
      this.calcGSD()
      //重新计算全局航线高度
      // this.calcHeightFromGSD(lens)
    },
    /**
     * 处理镜头选择变化
     * 当用户选择不同的镜头时，调用此方法来计算地面采样距离（GSD）。
     */
    handleSelectLensChange(val) {

      if (!this.editable) return
      let imgFormatArray = []
      if (val.includes("infrared")) {
        imgFormatArray.push("ir")


      }
      if (val.includes("wide")) {
        imgFormatArray.push("visable")
      }
      this.waylineConfig.imageFormat = imgFormatArray.join(",")

      this.calcGSD()


    },

    /**
     * 处理全局高度变化的方法
     */
    handleGlobalHeightChange(val) {
      if (!this.editable) return
      if (this.isAreaRoute || this.isGridWay) {
        //如果是面状航线或者是网格航线重新计算GSD值，通过计算GSD值来重新生成航点
        this.calcGSD()
      } else {
        //如果是点状航线，则直接更新所有航点的全局高度值
        let waypoints = this.waylineConfig.points || []
        waypoints.forEach(item => {
          item.altitude = val

        })

      }
    },

    /**
     * 处理GSD变化事件
     *
     * 当GSD（地面采样距离）发生变化时，该方法将被调用。
     * 该方法将重新计算全局航线高度，并生成航点。
     */
    handleGsdChange() {
      if (!this.editable) return
      //重新计算全局航线高度
      this.calcHeightFromGSD("wide")
      //重新计算红外相机GSD值，因为广角和红外相机的地面采样距离可能不同
      this.calcGSD("infrared")
      // this.generateWaypoints()
    },
    /**
     * 处理红外GSD 变化事件处理函数
     * @returns {void} 无返回值
     */
    handleGsdInfraredChange() {
      this.calcHeightFromGSD("infrared")
      //重新计算广角GSD值，因为红外相机和广角相机的地面采样距离可能不同
      this.calcGSD("wide")
      // this.generateWaypoints()
    },
    /**
     * 处理旁向重叠率输入变化事件
     * */
    handleSidelapChange() {
      if (!this.editable) return
      this.generateWaypoints()
    },
    /***
     * 处理航向重叠率变化事件
    */
    handleCourseChange() {
      if (!this.editable) return
      this.generateWaypoints()
    },

    /**
     * 计算GSD值
     *
     * 此方法用于计算GSD（地面采样距离）值。
     *
     * @returns {number} 返回计算得到的GSD值
     */
    calcGSD(lens) {
      let currentCamera = this.currentCamera
      if (currentCamera) {
        if (lens == "wide" || !lens) {
          //广角相机
          const wideCamera = currentCamera.wide
          if (wideCamera) {
            const { sensorWidth, focalLength, imageWidth } = wideCamera
            const globalHeight = this.waylineInfo.config.altitude
            const gsd = WaylineUtil.calcGSD(globalHeight, sensorWidth, focalLength, imageWidth)
            console.log(gsd, "gsd")
            this.waylineInfo.config.gsdWide = parseFloat(gsd)
          }
        }
        if (lens == "infrared" || !lens) {
          //红外相机
          const infraredCamera = currentCamera.infrared
          if (infraredCamera) {
            const { sensorWidth, focalLength, imageWidth } = infraredCamera
            const globalHeight = this.waylineInfo.config.altitude
            const gsd = WaylineUtil.calcGSD(globalHeight, sensorWidth, focalLength, imageWidth)

            this.waylineInfo.config.gsdInfrared = parseFloat(gsd)
          }
        }
      }
      this.generateWaypoints()
    },

    /**
     * 根据GSD计算高度
     *
     * @param lens 镜头类型，可选值为 "wide"（广角）或 "infrared"（红外）
     */
    calcHeightFromGSD(lens = "wide") {
      let currentCamera = this.currentCamera
      if (currentCamera) {
        //广角相机或者红外相机，默认广角相机
        let lensCamera = currentCamera.wide
        let gsd = this.waylineInfo.config.gsdWide
        if (lens == "infrared") {
          // 红外相机
          if (currentCamera.infrared) {
            lensCamera = currentCamera.infrared
            gsd = this.waylineInfo.config.gsdInfrared
          }
        }

        if (lensCamera) {
          const { sensorWidth, focalLength, imageWidth } = lensCamera

          const height = WaylineUtil.calcHeightFromGSD(gsd, sensorWidth, focalLength, imageWidth)

          this.waylineInfo.config.altitude = parseFloat(height)
        }
      }
      // this.generateWaypoints()
    },


    /**
     * 计算统计信息
     *
     * 根据传入的航线配置信息，计算航线的总距离、总时间和面积，并更新航线信息对象
     */
    calcStatistics() {
      if (!this.editable) return
      let waylineConfig = this.waylineConfig || {}

      const result = WaylineUtil.calculateDistanceAndTime(waylineConfig)

      this.waylineInfo.distance = result.totalDistance || 0
      this.waylineInfo.estimateTime = result.totalTime || 0
      this.$set(this.waylineInfo.config, "polygonArea", result.area || 0)
      this.$set(this.waylineInfo.config, "photos", result.photos || 0)

    },
    /**
     * 生成航点
     * 该方法根据当前相机参数，重叠率参数、网格信息、多边形边界范围生成航点。
     *
     * @returns 无返回值
     */
    generateWaypoints() {
      if (!this.editable) return
      const waylineInfo = this.waylineInfo
      const waylineConfig = this.waylineConfig || {}
      const { type, isGridWay } = waylineConfig
      if (type !== WaylineTemplateType.mapping2d
        && !isGridWay && type != WaylineTemplateType.polygon) {
        // 非（建图航拍、网格航线、非多边形航线），不通过边界范围去自动规划航点
        return
      }


      let gridInfo = this.gridInfo

      let polygonCoordinates = []
      if (gridInfo) {
        let geometryText = gridInfo.geometryText
        let coordinates = MapUtils.getCoordinatesFromWKT(geometryText)
        if (coordinates) {
          polygonCoordinates = coordinates[0]

        }
        // console.log(polygonCoordinates)
      } else {
        let regions = this.waylineConfig.regions || []
        polygonCoordinates = WaylineUtil.pointsToCoordinates(regions)
      }
      if (polygonCoordinates.length === 0) {
        console.error("请先绘制飞行区域")
        return
      }
      if (type == WaylineTemplateType.mapping2d || isGridWay) {
        const currentCamera = this.currentCamera
        if (!currentCamera) {
          return
        }
        //建图航拍、网格航线
        const { gsdWide, course, sidelap, gsdInfrared } = waylineInfo.config
        //广角相机
        const wideCamera = currentCamera.wide
        let { imageWidth, imageHeight } = wideCamera
        let gsd = gsdWide
        if (this.isInfraredLensChecked) {
          //如果选择了红外镜头，使用红外相机的GSD值
          let infraredCamera = currentCamera.infrared
          if (infraredCamera) {
            imageWidth = infraredCamera.imageWidth
            imageHeight = infraredCamera.imageHeight
            gsd = gsdInfrared
          }

        }



        let takeoffPoint = null// 起飞点坐标 [lng,lat]
        if (waylineInfo.config.latlng && waylineInfo.config.latlng.length > 0) {
          takeoffPoint = waylineInfo.config.latlng

        }

        let params = {
          polygon: polygonCoordinates,         // [[lng,lat], …] 闭合多边形
          gsd: gsd,        // cm/pixel 地面采样距离（厘米/像素）
          forwardOverlap: course,  // 航向重叠率 (0~100)
          sideOverlap: sidelap,     // 旁向重叠率 (0~100)
          imageWidth,      // 像素宽
          imageHeight,     // 像素高
          headingAngle: 0,  // 航向角度，度

        }
        if (takeoffPoint) {
          params.takeoffPoint = takeoffPoint
        }
        // console.log(params, "params===")
        let result = WaylineUtil.planFlight(params)
        let waypoints = result.waypoints || []
        let pointList = []
        waypoints.forEach(item => {
          item.heading = 0
          let obj = {
            speed: this.waylineInfo.config.speed,
            useGlobalSpeed: true,
            altitude: this.waylineInfo.config.altitude,
            longitude: item[0],
            latitude: item[1],
            shootPhoto: false,
            status: 0,
            actions: [
              {
                "type": "GIMBAL_PITCH",
                "params": -90
              },
              {
                "type": "START_TAKE_PHOTO",
                "params": 0
              }

            ]
          }
          pointList.push(obj)
        })
        this.waylineInfo.config.points = pointList

        this.waylineInfo.counts = pointList.length

      } else if (type === WaylineTemplateType.polygon) {
        //计算多边形航线航点

        let takeoffPoint = null// 起飞点坐标 [lng,lat]
        if (waylineInfo.config.latlng && waylineInfo.config.latlng.length > 0) {
          takeoffPoint = waylineInfo.config.latlng

        }

        let params = {
          coordinates: polygonCoordinates,         // [[lng,lat], …] 闭合多边形
          sidelapSpacing: this.waylineInfo.config.sidelapSpacing,
          forwardSpacing: this.waylineInfo.config.forwardSpacing,
          headingAngle: this.waylineInfo.config.rotate || 0,  // 航向角度，度

        }
        if (takeoffPoint) {
          params.takeoffPoint = takeoffPoint
        }
        //多边形航线生成
        let result = WaylineUtil.generaPolygonRoute(params)
        let waypoints = result.waypoints || []

        let pointList = []
        waypoints.forEach(item => {
          item.heading = 0
          let obj = {
            speed: this.waylineInfo.config.speed,
            useGlobalSpeed: true,
            altitude: this.waylineInfo.config.altitude,
            longitude: item[0],
            latitude: item[1],
            shootPhoto: false,
            status: 0,
            actions: [


            ]
          }
          pointList.push(obj)
        })
        this.waylineInfo.config.points = pointList

        this.waylineInfo.counts = pointList.length
      }

    },


    handleWaypointListChange(waypoints) {
      let list = waypoints || []
      this.waylineInfo.config.points = list
    },
    handleBatchDeleteWaypoint(startIndex, endIndex) {

      if (startIndex !== undefined && endIndex !== undefined) {
        if (startIndex > endIndex) {
          this.$message.error(this.$t('route.point.startLtEnd'));
        } else {
          let points = this.waylineInfo.config.points || []
          let start = startIndex - 1
          let end = endIndex - 1
          points.splice(start, (end - start + 1))
          this.waylineInfo.config.points = points
        }
      }


    },
    /**
     * 精准降落起始点和结束点选择变化的事件
     * @param event 
     * @param type 起始点或结束点
     */
    handleLandPointChange(event, type) {
      console.log(event, type)
      const targetPoint = this.landPointOptions.find(item => item.id === event)
      if (!targetPoint) return
      const { longitude, latitude, altitude } = targetPoint
      console.log(targetPoint, targetPoint)
      if (!longitude || !latitude) return

      const pointList = this.waylineInfo.config.points || []
      if (pointList.length === 0) return
      if (type === 'startPoint') {
        pointList[0].longitude = Number(longitude)
        pointList[0].latitude = Number(latitude)
      } else if (type === 'endPoint') {
        let lastIndex = pointList.length - 1
        pointList[lastIndex].longitude = Number(longitude)
        pointList[lastIndex].latitude = Number(latitude)
        if (altitude !== undefined) {
          this.waylineInfo.config.landHeight = Number(altitude)
        }
      }
    },
    /**
       * 获取机库站点列表
       */
    getDockSiteList() {
      DockApi.fetchSiteList().then((res) => {

        let list = []
        if (res.code === 200) {
          list = res.rows || []
        }
        this.dockSiteList = list

      });
    },
    /**
       * 获取降落点列表
       */
    getLandPointList() {
      RouteApi.fetchLandPointOptions().then((res) => {

        let list = []
        if (res.code === 200) {
          list = res.data || res.rows || []
        }
        console.log(res, "res===")
        this.landPointOptions = list
      });
    },

    saveClick() {

      this.validateWayline().then(valid => {
        if (valid) {

          this.$emit('save', this.waylineInfo)
        }

      })

    },
    /**
   * 校验航线配置是否合法
   */

    async validateWayline() {
      let result = true
      const config = this.waylineInfo.config
      const waylineType = this.waylineInfo.type
      return new Promise((resolve) => {
        if (this.$refs.formRef) {
          this.$refs.formRef.validate(async (valid) => {
            result = valid;
            if (!result) {
              resolve(result)
              return
            }
            if (this.$refs.configFormRef) {
              result = await this.$refs.configFormRef.validate()

              if (!result) {
                resolve(result)
                return
              }
            }

            if (!config) {
              result = false
              resolve(result)
              return;
            }

            let points = config.points || [];

            // 检查第一条规则,航点速度不能大于全局航线速度,没必要校验这个，暂时注释掉
            // let { speed } = config;
            // for (let i = 0; i < points.length; i++) {
            //   const p = points[i];
            //   if (Number(p.speed) > Number(speed)) {
            //     result = false;
            //     let msg = `${this.$t('route.waypoint.speedLimit')},${this.$t('route.waypoint.checkWaypointSpeed', [i + 1])}`
            //     this.$message.error(msg);
            //     resolve(result)
            //     return;
            //   }
            // }

            //航点航线才检查，一般航点航线才会设置航点参数
            if (waylineType == WaylineTemplateType.LineString) {
              if (points.length < 2) {
                result = false;
                this.$message.error(this.$t('route.waypoint.waypointRouteCountMin'));
                resolve(result)
                return;
              }
              let startRecordCount = 0//设置了开始录像 的action数量
              let stopRecordCount = 0//设置了停止录像的action数量
              for (let i = 0; i < points.length; i++) {
                const actions = points[i].actions || [];
                let isSetHead = false//是否设置了机头方向
                actions.forEach((action) => {
                  if (action.type === 'ROTATE_AIRCRAFT') {
                    isSetHead = true;
                  }
                  if (action.type === 'START_RECORD') {
                    startRecordCount += 1
                  }
                  if (action.type === 'STOP_RECORD') {
                    stopRecordCount += 1
                  }
                });

                if (config.headingMode === 'USING_WAYPOINT_HEADING') {
                  // 检查第二条规则，当全局“机头方向” 参数设置了“在航点中设置”时，不予保存，需要去设置航点动作
                  if (!isSetHead) {
                    //只要遍历到其中一个点没有设置机头方向，则校验不通过，没必要再遍历其他点了
                    result = false;
                    resolve(result)
                    return
                  }

                }

              }
              // 检查第三条规则，录像开始和结束的action数量是否一致，暂时注释，大疆航线没有这样的规定
              // if (startRecordCount !== stopRecordCount) {
              //   result = false;
              //   this.$message.error('录像开始和结束的航点动作数量不一致');
              //   resolve(result)
              //   return
              // }
            }
            if (config.flyMode === 2 && config.jumpSiteId === '') {
              this.$message.error('请选择跳飞站点');
              result = false;
            }

            resolve(result)

          });
        }
      })

    },
    cancelClick() {
      this.$emit('cancel')
    }
  },
  watch: {
    'waylineInfo.config.speed': {
      handler(val) {
        if (!this.editable) return
        this.debounceCalcStatistics()
      },
      immediate: false,
      deep: false
    },
    'waylineInfo.config.points': {
      handler(newVal, oldVal) {
        if (!this.editable) return
        this.debounceCalcStatistics()
      },
      immediate: false,
      deep: true
    },
    'waylineInfo.config.regions': {
      handler(val) {
        if (!this.editable) return
        this.generateWaypoints()

      },
      immediate: false,
      deep: true
    }
  },
  created() {
    this.debounceCalcStatistics = debounce(this.calcStatistics, 500)
    this.getDockSiteList()
    this.getLandPointList()
  },
  mounted() {

    if (!this.editable) return

    if (this.waylineInfo && this.waylineInfo.config) {

      if (this.waylineInfo.config.droneEnumValue == undefined) {
        this.$set(this.waylineInfo.config, "droneEnumValue", "")

      }
    }
  },
};
</script>


<style lang="scss" scoped>
$header-height: 56px;
$footer-height: 50px;
$tabs-header-height: 56px;

.wayline-settings {
  position: relative;
  height: 100%;

  ::v-deep .el-input__inner {
    background-color: #071150 !important;
  }

  &__header {
    height: $header-height;
    padding: 0px 12px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    background: #112d7b;
  }

  &__body {
    height: calc(100% - $header-height - $footer-height);
    position: relative;
  }

  &__footer {
    height: $footer-height;
    display: flex;
    box-sizing: border-box;
    background-color: #112d7b;
    align-items: center;
    justify-content: center;

    .el-btn {
      color: #49f0fd;
      border: 1px solid #49f0fd;
      background: rgba(46, 125, 248, 0.2);

      &.el-btn {
        margin-left: 40px
      }
    }

    ::v-deep .el-button--primary {
      color: #000000;
      background: linear-gradient(180deg, #1dc9ff 0%, #49f0fd 100%);
    }
  }



  .wayline-type {
    border-radius: 2px 2px 2px 2px;
    border: 1px solid #2e7df8;
    color: #2e7df8;
    padding: 6px 8px;
    font-size: 12px;
  }

  .wayline-stats-container {
    // display: flex;
    box-sizing: border-box;
    flex-wrap: wrap;

    .wayline-stats-item {

      min-width: 20px;
      text-align: center;
      padding: 8px;

      .value-wrapper {
        margin-bottom: 10px;
      }

      .value {
        font-size: 18px;
        font-weight: 700;
      }

      .unit {
        font-size: 12px;
        color: rgba(255, 255, 255, 0.8);
        margin-left: 4px
      }

      .label {
        color: rgba(255, 255, 255, 0.9);
        font-weight: 400;
        line-height: 1.3;
      }
    }
  }

  .wayline-tabs {
    height: calc(100% - 124px);
    position: relative;

    &__header {
      position: relative;
      height: $tabs-header-height;
      overflow: hidden;
      background: #112d7b;
      box-shadow: 0px 1px 0px 0 #000000;
      display: flex;
      align-items: center;
      box-sizing: border-box;
    }

    &__item {
      height: 100%;
      font-size: 16px;
      font-family: Microsoft YaHei-Bold, Microsoft YaHei;
      font-weight: bold;
      color: #ffffff;
      cursor: pointer;
      flex: 1;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      border-bottom: 2px solid transparent;

      &.is-active {
        border-bottom: 2px solid #2e7df8;
      }
    }

    &__content {

      height: calc(100% - $tabs-header-height);
      position: relative;
    }

    .c-scrollbar {
      height: 100%;

      &__content {
        padding: 12px 16px;
      }
    }

    .form-item-content {
      font-size: 14px;
      display: flex;
      align-items: center;
    }

    .form-item-label {
      flex: 1
    }

    .icon-img {
      height: 20px;
      width: 20px;
      margin-right: 5px;
    }

    .input-number {
      width: 120px
    }

    .slider-wrapper {
      padding: 0px 10px
    }

    .el-checkbox-only-child:last-child {
      ::v-deep .el-checkbox-button {

        .el-checkbox-button__inner {
          border-radius: 4px 4px 4px 4px;


        }
      }
    }

    ::v-deep.el-checkbox-button.is-checked .el-checkbox-button__inner {
      color: #FFF !important;
      background-color: #112d7b !important;
      border-color: #2e7df8 !important;
      //box-shadow: -1px 0 0 0 #2e7df8 !important;
    }

    ::v-deep .el-checkbox {
      color: #fff !important;

      &.is-bordered.is-checked {
        border-color: #2e7df8 !important;

        .el-checkbox__inner {
          background-color: #409EFF !important;
          border-color: #409EFF !important;
        }
      }



    }

    // ::v-deep .el-checkbox__input.is-disabled+span.el-checkbox__label {
    //   color: #409EFF !important;
    // }

    ::v-deep .camera-lens-checkbox {
      margin-left: 0px;
      margin-right: 0px;

      &+.camera-lens-checkbox {
        margin-left: 4px;
      }
    }

    ::v-deep .el-checkbox {
      margin-right: 10px;

      &__label {
        padding-left: 6px;
      }

      &__input.is-checked+.el-checkbox__label {
        color: #409EFF !important;
      }

      &__input.is-checked .el-checkbox__inner,
      .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: #409EFF !important;
        border-color: #409EFF !important;
      }
    }


    /* 选中未 checked 的 inner */
    ::v-deep .el-radio-button__orig-radio {
      &:not(:checked)+.el-radio-button__inner {
        background-color: #DCDFE6;

      }

      &:checked+.el-radio-button__inner {
        color: #FFF !important;
        background-color: #409EFF !important;
        border-color: #409EFF !important;
        box-shadow: -1px 0 0 0 #409EFF !important;
      }

      &:disabled+.el-radio-button__inner {
        color: #606266 !important;

      }
    }

    ::v-deep .el-radio {
      color: #ffffff;

      &:not(:last-child) {
        margin-right: 6px;
      }

      &__label {
        padding-left: 0px;
      }

      &.is-bordered.is-checked {
        border-color: #2e7df8 !important;

      }

      .el-radio__input.is-checked+.el-radio__label {
        color: #409EFF !important;
      }

      .el-radio__input.is-checked .el-radio__inner {
        border-color: #409EFF !important;
        background: #409EFF !important;
      }

    }




  }
}
</style>